export type ProjectFormTabKey = 'dados' | 'slas' | 'processos' | 'documentos' | 'links';

export function getVisibleProjectFormTabs(isEdit: boolean): ProjectFormTabKey[] {
    if (isEdit) {
        return ['dados', 'slas', 'processos', 'documentos', 'links'];
    }
    return ['dados', 'slas', 'links'];
}
